var map = {
	"./flag-de.png": 2269,
	"./flag-en.png": 2270,
	"./flag-es.png": 2271,
	"./flag-fr.png": 2272,
	"./flag-it.png": 2273,
	"./flag-ja.png": 2274,
	"./flag-mobile-de.png": 2275,
	"./flag-mobile-en.png": 2276,
	"./flag-mobile-es.png": 2277,
	"./flag-mobile-fr.png": 2278,
	"./flag-mobile-it.png": 2279,
	"./flag-mobile-ja.png": 2280,
	"./flag-mobile-pt.png": 2281,
	"./flag-mobile-ru.png": 2282,
	"./flag-mobile-zh-cn.png": 2283,
	"./flag-pt.png": 2284,
	"./flag-ru.png": 2285,
	"./flag-zh-cn.png": 2286
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2322;



//////////////////
// WEBPACK FOOTER
// ./src/components/LangSelector ^\.\/flag\-.*\.png$
// module id = 2322
// module chunks = 1